var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileInvoiceDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 65,
    viewBox: "0 0 74 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18616_83945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7321 2.73205L2.73205 54.6936L40.8372 76.6936L60.8372 42.0526L43.5167 32.0526L53.5167 14.7321L32.7321 2.73205ZM61.1227 39.908L54.8362 16.4465L46.2487 31.3205L61.1227 39.908ZM33.7321 1L56.2487 14L63.5692 41.3205L41.5692 79.4256L0 55.4256L32 0L33.7321 1ZM32.9282 14.3923L43.3205 20.3923L42.3205 22.1244L31.9282 16.1244L32.9282 14.3923ZM28.9282 21.3205L39.3205 27.3205L38.3205 29.0526L27.9282 23.0526L28.9282 21.3205ZM39.1506 37.6147L37.6506 40.2128L41.1147 42.2128L40.1147 43.9449L34.334 40.6074C32.7427 39.6886 30.7107 40.2331 29.792 41.8244C28.9795 43.2317 29.3033 45.0208 30.5623 46.0652L34.293 49.1285C36.3105 50.784 36.8218 53.6484 35.5155 55.9109C34.0405 58.4657 30.7854 59.3287 28.2415 57.86L27.6569 57.5225L26.1569 60.1206L24.4248 59.1206L25.9248 56.5225L21.5947 54.0225L22.5947 52.2904L29.2415 56.1279C30.8328 57.0467 32.8647 56.5022 33.7835 54.9109C34.596 53.5036 34.2722 51.7145 33.0132 50.6701L29.2825 47.6069C27.265 45.9513 26.7537 43.0869 28.0599 40.8244C29.5349 38.2696 32.7901 37.4066 35.334 38.8753L35.9186 39.2128L37.4186 36.6147L39.1506 37.6147Z",
    fill: "#333E64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18616_83945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 64,
    fill: "white",
    transform: "translate(32) rotate(30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInvoiceDollar);
export default __webpack_public_path__ + "static/media/file-invoice-dollar.304ed800f7c4417ce379a059537c3151.svg";
export { ForwardRef as ReactComponent };